import axios from 'axios';
import { authService } from '../../features/auth/services/authService';
import { useAuthStore } from '../../features/auth/store/authStore';
import { Timestamp } from 'firebase/firestore';

console.log(import.meta.env.VITE_API_URL)

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add authentication token to requests
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle API response errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      // Handle authentication errors
      if (
        error.response.status === 401 &&
        (error.response.data?.error === 'Invalid token' ||
          error.response.data?.error === 'Token expired')
      ) {
        return authService.handleSessionExpired();
      }

      // Return server error response
      return Promise.reject(error.response.data);
    }

    // Handle network or other errors
    return Promise.reject(error);
  }
);

// Transform Firebase Timestamps in responses
api.interceptors.response.use((response) => {
  const transformTimestamp = (obj: any) => {
    for (const key in obj) {
      const value = obj[key];
      
      // Check if value is a Firebase Timestamp-like object
      if (value && typeof value === 'object' && '_seconds' in value && '_nanoseconds' in value) {
        obj[key] = new Timestamp(value._seconds, value._nanoseconds);
      } 
      // Recursively transform nested objects
      else if (value && typeof value === 'object') {
        transformTimestamp(value);
      }
    }
    return obj;
  };

  response.data = transformTimestamp(response.data);
  return response;
});

// Connection endpoints
export const connectionEndpoints = {
  getState: (targetUserId: string) => `/connections/state/${targetUserId}`,
  request: '/connections/request',
  approve: (connectionId: string) => `/connections/${connectionId}/approve`,
  reject: (connectionId: string) => `/connections/${connectionId}/reject`,
} as const;

export default api;
